import { render, staticRenderFns } from "./ContentPadding.vue?vue&type=template&id=21e355ff&scoped=true&"
import script from "./ContentPadding.vue?vue&type=script&lang=js&"
export * from "./ContentPadding.vue?vue&type=script&lang=js&"
import style0 from "./ContentPadding.vue?vue&type=style&index=0&id=21e355ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e355ff",
  null
  
)

export default component.exports